import React from 'react';
import { useTranslation } from 'react-i18next';
import './MetricWidget.css';

const MetricWidget = ({ data, config }) => {
    const { t } = useTranslation();
    // Handle missing or invalid data - default to 0
    const value = data?.value ?? 0;
    const { trend, percentage, targetValue, maxValue } = data || {};

    // Format value based on config.format
    const formatValue = (val) => {
        switch (config?.format) {
            case 'duration':
                // Convert seconds to mm:ss format
                const minutes = Math.floor(val / 60);
                const seconds = Math.floor(val % 60);
                return `${minutes}:${seconds.toString().padStart(2, '0')}`;

            case 'percentage':
                return `${val % 1 === 0 ? val.toFixed(0) : val.toFixed(1)}%`;

            case 'number':
            default:
                return val.toLocaleString();
        }
    };

    // Determine color class based on current value vs target and max thresholds
    // GREEN: value < target (goal achieved)
    // ORANGE: target ≤ value < max (warning zone)
    // RED: value ≥ max (exceeded limit)
    let colorClass = '';
    if (targetValue !== undefined && targetValue !== null && maxValue !== undefined && maxValue !== null && maxValue > 0) {
        // Use min/max so the logic works regardless of which threshold is numerically larger
        const lowerThreshold = Math.min(targetValue, maxValue);
        const upperThreshold = Math.max(targetValue, maxValue);

        if (value < lowerThreshold) {
            colorClass = 'value-green';
        } else if (value < upperThreshold) {
            colorClass = 'value-orange';
        } else {
            colorClass = 'value-red';
        }
    }

    return (
        <div className="metric-widget">
            <div className={`metric-value ${colorClass}`}>
                {formatValue(value)}
            </div>

            {/* Display target and max if available */}
            {targetValue !== undefined && targetValue !== null && (
                <div className="metric-thresholds">
                    <div className="metric-target">
                        <span className="threshold-label">{t('TARGET')}:</span>
                        <span className="threshold-value">{formatValue(targetValue)}</span>
                    </div>
                    {maxValue !== undefined && maxValue !== null && (
                        <div className="metric-max">
                            <span className="threshold-label">{t('MAX')}:</span>
                            <span className="threshold-value">{formatValue(maxValue)}</span>
                        </div>
                    )}
                </div>
            )}

            {/* Display percentage if available and no target */}
            {!targetValue && percentage !== undefined && percentage !== null && (
                <div className="metric-trend">{percentage % 1 === 0 ? percentage.toFixed(0) : percentage.toFixed(1)}%</div>
            )}
        </div>
    );
};

export default MetricWidget;
